import Api from '@/utils/api';
import {
  ValidationProvider,
} from 'vee-validate';
import warning from './warning/index.vue';

export default {
  components: {
    ValidationProvider,
    warning,
  },
  data() {
    return {
      // columns for sorting
      errorCategoriesColumns: [
        'Name',
        'Abbreviation',
        'CodeNumberNew',
        'CodeNumber',
        'Position',
      ],
      // So, this object created because name columns in getting array is different from text in columns
      errorCategoriesColumnsText: {
        'Name': 'Name (long)',
        'Abbreviation': 'Name (short)',
        'CodeNumberNew': 'Error code QA report (new)',
        'CodeNumber': 'Error code QA report (old)',
        'Position': 'Sorting order for scroll-down menu',
      },

      errorCategories: [],
      isSaveButtonDisabled: false,
      isAddButtonIsDisabled: true,

      selectedErrorCategory: {},
      creatingErrorCategory: null,
      selectedErrorCategoryTpl: {
        ID: null,
        Name: '',
        Abbreviation: '',
        CodeNumberNew: '',
        CodeNumber: '',
        Position: '',
      },

      showModalType: false,

      sortOrders: {},
      sortKey: '',
    };
  },

  created() {
    this.getErrorCategories();
  },

  methods: {

    /**
     * Get all error categories
     */
    getErrorCategories() {
      Api.settings.errorConfiguration
        .get()
        .then((data) => {
          if (!data.data.Status) {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
            return;
          }
          this.errorCategories = data.data.Data;

          this.errorCategories.sort((a, b) => {
            return a.CodeNumber - b.CodeNumber;
          });

          this.errorCategoriesColumns.forEach((key) => {
            this.sortOrders[key] = 1;
          });
          this.errorCategories = this.errorCategories.map((value) => {
            this.$set(value, 'ShowEditable', false);
            return value;
          });
        }).catch((error) => {
          this.errorCategories = null;
        });
    },

    /**
     * Create new category
     */
    createErrorCategory() {
      Api.settings.errorConfiguration
        .create(this.creatingErrorCategory)
        .then((response) => {
          if (response.data.Status) {
            this.creatingErrorCategory = {};
            // console.log(response.data.Data);
            this.$set(response.data.Data, 'ShowEditable', false);
            this.errorCategories.push(response.data.Data);
            this.isAddButtonIsDisabled = true;
            this.resetInputValidation();

            this.$root.$emit('notification', {
              message: 'Category was created!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });

      // this.hideErrorCategoryEditor();
    },

    /**
     * Update category
     */
    updateErrorCategory(currentCategory) {
      Api.settings.errorConfiguration
        .update(this.selectedErrorCategory)
        .then((data) => {
          if (data.data.Status) {
            this.selectedErrorCategory = {};
            this.getErrorCategories();
            this.$root.$emit('notification', {
              message: 'Category was updated!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.message,
              type: 'error',
              show: true,
            });
          }
        });

      // this.hideErrorCategoryEditor();
    },

    /**
     * Disable category
     */
    disableErrorCategory(id) {
      Api.settings.errorConfiguration
        .disable(id)
        .then((data) => {
          if (data.data.Status) {
            let errorCategoryActive;

            this.errorCategories.forEach((value, index) => {
              if (value.ID === id) {
                this.errorCategories[index].Active = !this.errorCategories[index].Active;
                errorCategoryActive = this.errorCategories[index].Active;
              }
            });

            this.$root.$emit('notification', {
              message: `Category was ${errorCategoryActive ? 'activated' : 'disabled'}!`,
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * Delete category
     */
    deleteErrorCategory(id) {
      Api.settings.errorConfiguration
        .delete(id)
        .then((data) => {
          if (data.data.Status) {
            this.errorCategories.forEach((value, index) => {
              if (value.ID === id) {
                this.errorCategories.splice(index, 1);
              }
            });

            this.$root.$emit('notification', {
              message: 'Category was deleted!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    holderRemoveErrorCategory(id) {
      this.$modal.show('dialog', {
        title: 'Warning!',
        text: 'Are you sure you want to delete this error category?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.deleteErrorCategory(id);
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    /**
     * Method handler for add / change error category item
     *
     * @param {Object} errorCategory
     * @param {String} type
     */
    handlerErrorCategory(errorCategory, type) {
      this.selectedErrorCategory = errorCategory;
      this.showModalType = type;
      this.showModalType = type;
    },

    /**
     * Method hide modal and clear selected category
     */
    hideErrorCategoryEditor() {
      this.showModalType = false;
      this.selectedErrorCategory = null;
    },

    /**
     * Method for sorting general
     *
     * @param {Number} key
     */
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.sortTable();
    },

    /**
     * Method for sort table
     */
    sortTable() {
      var order = this.sortOrders[this.sortKey];

      if (this.sortKey) {
        this.errorCategories = this.errorCategories.slice().sort((a, b) => {
          a = a[this.sortKey];
          b = b[this.sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
    },

    /**
     *
     * Method for disable save button
     * @param {Number} ix Current row index
     */
    checkIsFieldValid(ix) {
      setTimeout(() => {
        if (ix == -1) {
          for (const key in this.$refs) {
            if (key.split('_').length == 1) {
              continue;
            }
            const isValid = this.$refs[key].isValid;
            if (!isValid) {
              this.isAddButtonIsDisabled = true;
              return;
            }
          }
          this.isAddButtonIsDisabled = false;
        } else {
          for (const key in this.$refs) {
            if (key.split('_').length == 2) {
              continue;
            }
            const isValid = this.$refs[key][ix].flags.valid;
            if (!isValid) {
              this.isSaveButtonDisabled = true;
              return;
            }
          }
          this.isSaveButtonDisabled = false;
        }
      }, 500);
    },

    /**
     * Method for handle showing/hiding placeholder for input
     * @param {Event} $event - event object
     * @param {*} value - placeholder value (if blur event)
     */
    placeholderHandler($event, value) {
      if ($event.type == 'focus') {
        $event.target.removeAttribute('placeholder');
      } else if ($event.type == 'blur') {
        $event.target.setAttribute('placeholder', value);
      }
    },

    makeEditable(category) {
      this.selectedErrorCategory = Object.assign({}, category);
      category.ShowEditable = !category.ShowEditable;
    },

    makeReadonly(category) {
      category.ShowEditable = false;
      this.selectedErrorCategory = {};
    },

    clearInputData() {
      this.creatingErrorCategory = {};
      this.isAddButtonIsDisabled = true;
      this.resetInputValidation();
    },
    resetInputValidation() {
      for (const key in this.$refs) {
        if (key.split('_').length == 1) {
          continue;
        }
        this.$refs[key].reset();
      }
    },
  },
};
